import { render, staticRenderFns } from "./mbmsg.vue?vue&type=template&id=7f0d41c9&scoped=true"
import script from "./mbmsg.vue?vue&type=script&lang=js"
export * from "./mbmsg.vue?vue&type=script&lang=js"
import style0 from "./mbmsg.vue?vue&type=style&index=0&id=7f0d41c9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0d41c9",
  null
  
)

export default component.exports